import { ValidationError } from 'src/errors/CustomErrors';
import { DimensionSpecs, VideoLengthSpecs } from 'src/utils/Types';
import { validateVideoDimensions, validateVideoLength } from 'src/utils/validations/Videos';

import {
  AbstractAssetInputHandler,
  AbstractAssetInputHandlerProps,
} from './AbstractAssetInputHandler';

interface VideoInputHandlerProps extends AbstractAssetInputHandlerProps {
  maxDurationInSeconds: number;
  minDurationInSeconds: number;
}

class VideoInputHandler extends AbstractAssetInputHandler {
  private readonly maxDurationInSeconds: number;
  private readonly minDurationInSeconds: number;
  constructor({
    minDurationInSeconds,
    maxDurationInSeconds,
    ...baseProps
  }: VideoInputHandlerProps) {
    super(baseProps);
    this.maxDurationInSeconds = maxDurationInSeconds;
    this.minDurationInSeconds = minDurationInSeconds;
  }
  protected async validateFileObject(
    fileObject: File,
    dimensionSpecs: DimensionSpecs,
  ): Promise<void> {
    try {
      await validateVideoDimensions(fileObject, dimensionSpecs);
      const specs: VideoLengthSpecs = {
        minDurationInSeconds: this.minDurationInSeconds,
        maxDurationInSeconds: this.maxDurationInSeconds,
      };
      await validateVideoLength(fileObject, specs);
    } catch (error) {
      throw error instanceof ValidationError
        ? error
        : new ValidationError('Video validation failed');
    }
  }
}

export { VideoInputHandler };
